import axios from 'axios';

// Access environment variables
const AIRTABLE_BASE_ID = process.env.REACT_APP_AIRTABLE_BASE_ID;
const AIRTABLE_TABLE_NAME = process.env.REACT_APP_AIRTABLE_TABLE_NAME;
const AIRTABLE_TOKEN = process.env.REACT_APP_AIRTABLE_TOKEN;

const airtableInstance = axios.create({
  baseURL: `https://api.airtable.com/v0/${AIRTABLE_BASE_ID}/${AIRTABLE_TABLE_NAME}`,
  headers: {
    Authorization: `Bearer ${AIRTABLE_TOKEN}`,
    'Content-Type': 'application/json'
  }
});

export const getRecordById = async (id) => {
  const response = await airtableInstance.get(`/${id}`);
  return response.data;
};

export const createRecord = async (fields) => {
  const response = await airtableInstance.post('/', { fields });
  return response.data;
};

export const updateRecord = async (id, fields) => {
  console.log("Updating record with ID:", id);
  console.log("Fields:", fields);
  const response = await airtableInstance.patch(`/${id}`, { fields });
  return response.data;
};

export const deleteRecord = async (id) => {
  const response = await airtableInstance.delete(`/${id}`);
  return response.data;
};

export const getRecords = async () => {
  const response = await airtableInstance.get('/');
  return response.data.records;
};